import type { AddressBook } from './AddressBook';

export const base: AddressBook = {
    enabled: true,
    _description: 'Enables Address book feature',
    prefilling: {
        enabled: true,
        _description: 'Enables automatic transfer form prefilling based on previous payments',
    },
    templates: {
        scheduler: {
            _description: 'Enables templates scheduler',
            enabled: false,
        },
        bulk: {
            enabled: false,
            _description: 'Enables bulk templates in address book',
        },
    },
    favourites: {
        enabled: true,
        _description: 'Enables marking contacts as favourites',
    },
};
